import { type ReactNode } from 'react';
import clsx from 'clsx';
import { useAccountsStore, useSidebarStore } from '@lib/store';
import { useResponsive } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';
import { InnerPageLayout } from '../innerPageLayout';
import { Subheader } from '../../subheader';
import { AccountsSelect } from '@widgets/AccountsSelect';
import { Sidebar } from '@widgets/Sidebar';
import { Logo, Spinner } from '@shared/widgets';

interface LayoutProps {
  loading?: boolean;
  isMain?: boolean;
  isProfile?: boolean;
  header?: string | ReactNode;
  sidebar?: boolean;
  blank?: boolean;
  children: ReactNode;
}

export const Layout = (props: LayoutProps) => {
  const accountsStore = useAccountsStore();
  const sidebarStore = useSidebarStore();

  const { isSmallScreen } = useResponsive();

  const isLoading = props.loading || accountsStore.loading;
  return (
    <InnerPageLayout>
      <div className='min-h-[300px] max-[840px]:pt-15'>
        {isLoading && <Spinner className='min-h-[200px]' />}
        {!isLoading && (
          <>
            <div
              className={clsx(
                'hidden max-[840px]:flex h-15 fixed top-0 w-full  items-center justify-center z-10',
                PaletteUtils.isBordierPalette ? 'bg-white border-b border-b-[#1e1e21]' : 'bg-[#1e1e21]',
              )}
            >
              {props.isMain && <Logo className='flex items-center justify-center' />}
            </div>

            <AccountsSelect
              className={clsx(
                'w-full max-[840px]:hidden max-[840px]:pt-15',
                props.isMain && 'max-[840px]:h-auto max-[840px]:!block max-[840px]:!pt-0 ',
              )}
              show={props.sidebar}
            />
            <div className={clsx('flex items-start', props.isMain && 'max-lg:ml-15 max-[840px]:justify-center  max-[840px]:!ml-5 max-[840px]:!mx-5')}>
              <Sidebar
                className={clsx(
                  'flex-[0_0_261px] mr-[50px] transition-all duration-300',
                  isSmallScreen && 'absolute z-10 left-0 bg-[#27272b] py-0 px-2.5 w-[281px]',
                  {
                    'ml-[-311px] opacity-0 pointer-events-none': !props.sidebar || (isSmallScreen && sidebarStore.data),
                  },

                  props.isMain && 'max-[840px]:grow-1 max-[840px]:max-w-[500px] max-[840px]:m-0 max-[840px]:py-0 ',
                  !props.isMain && 'max-[840px]:hidden',
                )}
              />

              <div className={clsx('flex flex-col mb-8 flex-1 min-w-[1px] ', props.isMain && 'max-[840px]:hidden')}>
                {typeof props.header === 'string' ? <Subheader>{props.header}</Subheader> : props.header}

                {props.blank ? (
                  <div className={clsx(PaletteUtils.isBordierPalette ? 'border border-[#e1e1e1]' : 'bg-[#fcfcfc]', props.isMain && '!border-0 ')}>
                    {props.children}
                  </div>
                ) : (
                  props.children
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </InnerPageLayout>
  );
};
